import { Component, Input, OnInit } from '@angular/core';
import { ImmigrationApi, ImmigrationCandidate } from 'src/app/core/api.gen';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LoaderService } from 'src/app/core/loader.service';
import { CommonService } from '../../services/visatypes/visa-steps/KSA';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { LookupTypeKeys } from 'src/app/shared/lookup-type-keys';
import { StepTypeImmigration } from '../../services/immigration.service';
import { ToastService } from 'src/app/core/toast.service';
import { isNullOrUndefined } from 'src/app/core/utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'eos-exit-team-leads',
  templateUrl: './exit-team-leads.component.html',
  styleUrls: ['./exit-team-leads.component.css']
})
export class ExitTeamLeadsComponent implements OnInit {

  constructor(
    private immigrationService: ImmigrationApi,
    private loader: LoaderService,
    public modal: NgbActiveModal,
    private toast: ToastService,
    private common: CommonService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService
  ) {
    this.common.prepareLookupObservable(LookupTypeKeys.MULTI_EXIT_QUESTIONS).subscribe(
      options => {
        this.options = options.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
      });
    this.activeRoute.params.subscribe(routeParams => {
      if (routeParams) {
        this.candidateId = parseInt(routeParams.id);
        this.visaType = routeParams.type;
        this.country = routeParams.country;
      }
    });
    common.immigrationCountry = this.country;
  }

  steps: any;
  @Input() inModal: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() visaType: any;
  teamTitle: string = '';
  isSubmit: boolean = false;
  @Input() country: any;
  model: any = {};
  @Input() candidateId: number;
  activeIds = [];
  showComment: boolean = false;
  formArray: any;
  options: any;
  controlArray: any[] = ['involuntaryexit', 'voluntaryexit', 'legalEntities']
  controlArrayComment: any[] = ['involuntaryexitComment', 'voluntaryexitComment', 'legalEntitiesComment']
  // options: any = [{ label: 'Employee is not in the currently in the offboarding process. No objection to proceed with renewal.', value: 1 }, { label: 'Employee is not in the currently in the process of LE transfer. No objection to proceed with renewal.', value: 2 }, { label: 'Employee is currently in the offboarding process. Do not proceed with renewal.', value: 3 }, { label: 'Employee is currently in the process of LE transfer. Do not proceed with renewal.', value: 4 }];
  ngOnInit(): void {
    this.getImmigrationProfileDetails();
    this.steps = this.GetSteps();
    for (let i = 0; i < this.steps.length; i++) {
      this.activeIds.push('panel-' + i);
    }
    this.formArray = new UntypedFormGroup({
      involuntaryexit: new UntypedFormControl(),
      voluntaryexit: new UntypedFormControl(),
      legalEntities: new UntypedFormControl(),
      involuntaryexitComment: new UntypedFormControl(''),
      voluntaryexitComment: new UntypedFormControl(''),
      legalEntitiesComment: new UntypedFormControl(''),
    })
    this.steps[0].hideSaveAndSubmit = !(this.authService.ActiveUser.roles.indexOf('Involuntary Exit Leads') > -1);
    this.steps[1].hideSaveAndSubmit = !(this.authService.ActiveUser.roles.indexOf('Voluntary Exit Leads') > -1);
    this.steps[2].hideSaveAndSubmit = !(this.authService.ActiveUser.roles.indexOf('LE Transfers') > -1);
  }
  getImmigrationProfileDetails() {//to get candidateprofile and pbprofile data
    this.loader.show();
    if (this.candidateId > 0) {
      // this.loader.show();
      this.immigrationService.immigrationProfile(this.candidateId).pipe(
        finalize(() => this.loader.clear())
      ).subscribe(resp => {
        this.model = resp;
        this.formArray.setValue({
          involuntaryexit: this.model.involuntaryExitId,
          voluntaryexit: this.model.voluntaryExitId,
          legalEntities: this.model.legalEntitiesId,
          involuntaryexitComment: isNullOrUndefined(this.model?.involuntaryExitComment) ? '' : this.model?.involuntaryExitComment,
          voluntaryexitComment: isNullOrUndefined(this.model?.voluntaryExitComment) ? '' : this.model?.voluntaryExitComment,
          legalEntitiesComment: isNullOrUndefined(this.model?.legalEntitiesComment) ? '' : this.model?.legalEntitiesComment
        });
        if (!isNullOrUndefined(this.model?.involuntaryExitComment) && this.model?.involuntaryExitComment != "")
          this.steps[0].showComment = true;
        if (!isNullOrUndefined(this.model?.voluntaryExitComment) && this.model?.voluntaryExitComment != "")
          this.steps[1].showComment = true;
        if (!isNullOrUndefined(this.model?.legalEntitiesComment) && this.model?.legalEntitiesComment != "")
          this.steps[2].showComment = true;
        this.steps[0].enableSaveAndSubmit = !isNullOrUndefined(this.model?.involuntaryExitId);
        this.steps[1].enableSaveAndSubmit = !isNullOrUndefined(this.model?.voluntaryExitId);
        this.steps[2].enableSaveAndSubmit = !isNullOrUndefined(this.model?.legalEntitiesId);
      });
    }
  }
  close() {
    this.modal.close(this.model);
  }
  save(index, flag) {
    this.isSubmit = flag ? true : false;
    if (index == 0) {
      this.model.involuntaryExitId = this.formArray.get('involuntaryexit').value;
      this.model.involuntaryExitComment = this.formArray.get('involuntaryexitComment').value;
      this.teamTitle = 'Involuntary Exit';
    }
    else if (index == 1) {
      this.model.voluntaryExitId = this.formArray.get('voluntaryexit').value;
      this.model.voluntaryExitComment = this.formArray.get('voluntaryexitComment').value;
      this.teamTitle = 'Voluntary Exit';
    }
    else if (index == 2) {
      this.model.legalEntitiesId = this.formArray.get('legalEntities').value;
      this.model.legalEntitiesComment = this.formArray.get('legalEntitiesComment').value;
      this.teamTitle = 'Legal Entities'
    }
    this.saveProfile();
  }
  getImmigrationCandidate() {
    const model = new ImmigrationCandidate();
    model.init({
      profile: this.model,
      countryCode: this.country,
      visaType: this.visaType,
      immigrationComment: null
    });
    return model;
  }
  saveProfile() {
    this.dateUtcConversion();
    const profile = this.getImmigrationCandidate();
    this.loader.show();
    this.immigrationService.saveRequestTeam(this.teamTitle, this.isSubmit, profile).pipe(finalize(() => this.loader.clear())).subscribe(resp => {
      this.model = resp.data;
      this.formArray.setValue({
        involuntaryexit: this.model?.involuntaryExitId,
        voluntaryexit: this.model?.voluntaryExitId,
        legalEntities: this.model?.legalEntitiesId,
        involuntaryexitComment: isNullOrUndefined(this.model?.involuntaryExitComment) ? '' : this.model?.involuntaryExitComment,
        voluntaryexitComment: isNullOrUndefined(this.model?.voluntaryExitComment) ? '' : this.model?.voluntaryExitComment,
        legalEntitiesComment: isNullOrUndefined(this.model?.legalEntitiesComment) ? '' : this.model?.legalEntitiesComment
      });
      if (!isNullOrUndefined(this.model?.involuntaryExitComment) && this.model?.involuntaryExitComment != "")
        this.steps[0].showComment = true;
      if (!isNullOrUndefined(this.model?.voluntaryExitComment) && this.model?.voluntaryExitComment != "")
        this.steps[1].showComment = true;
      if (!isNullOrUndefined(this.model?.legalEntitiesComment) && this.model?.legalEntitiesComment != "")
        this.steps[2].showComment = true;
        this.steps[0].enableSaveAndSubmit = !isNullOrUndefined(this.model?.involuntaryExitId);
        this.steps[1].enableSaveAndSubmit = !isNullOrUndefined(this.model?.voluntaryExitId);
        this.steps[2].enableSaveAndSubmit = !isNullOrUndefined(this.model?.legalEntitiesId);
      this.toast.success("Request saved successfully!");
    });;
  }

  OnCheck(index, value) {
    if (index == 0 && !this.steps[index].hideSaveAndSubmit) {
      this.steps[index].enableSaveAndSubmit = true;
      this.formArray.patchValue({
        involuntaryexitComment: ''
      })
      this.steps[index].showComment = !(value == 15175 || value == 15176);
    }
    else if (index == 1 && !this.steps[index].hideSaveAndSubmit) {
      this.steps[index].enableSaveAndSubmit = true;
      this.formArray.patchValue({
        voluntaryexitComment: ''
      })
      this.steps[index].showComment = !(value == 15175 || value == 15176);
    }
    else if (index == 2 && !this.steps[index].hideSaveAndSubmit) {
      this.steps[index].enableSaveAndSubmit = true;
      this.formArray.patchValue({
        legalEntitiesComment: ''
      })
      this.steps[index].showComment = !(value == 15175 || value == 15176);
    }
  }

  GetSteps(): StepTypeImmigration[] {
    var steps: StepTypeImmigration[] = [];
    steps.push(
      {
        label: "HR Ops (Involuntary exits)",
        role: 'involuntaryExitTeam',
        teamInfoprop: 'involuntaryExitTeam',
        enableSaveAndSubmit: false,
        hideSaveAndSubmit: false,
        showComment: false
      }
    );
    steps.push(
      {
        label: "MENA Offboarding (Voluntary exits)",
        role: 'voluntaryExitTeam',
        teamInfoprop: 'voluntaryExitTeam',
        enableSaveAndSubmit: false,
        hideSaveAndSubmit: false,
        showComment: false
      }
    );
    steps.push(
      {
        label: "Legal Entity Transfers",
        role: 'legalEntitiesTeam',
        teamInfoprop: 'legalEntitiesTeam',
        enableSaveAndSubmit: false,
        hideSaveAndSubmit: false,
        showComment: false
      }
    );
    return steps;
  }
  dateUtcConversion() {
    const pathWithProp =
      ["bioMetricCompletedDate", "civilIdExpiryDate", "cprExpiryDate", "cprIssuanceDate", "currentKSABusinessVisaExpiryDate",
        "dateCourierTrackingNumberSent", "dateDocumentAttestationCompleted", "dateHardCopyVisaDocumentsReceivedByVendorOrNJ",
        "dateHardcopyVisaDocumentsSent", "dateKSABusinessVisaExpiry", "dateOfBirth", "dateOfExit", "dateOfGatePassIssuance",
        "dateOfInvitationLetterIssuance", "dateOfPayment", "dateOfTravel", "dateSoftcopyVisaDocumentsSent", "departureDate",
        "dependentFinalExitDeadline", "dependentRPExpiryDate", "dependentRPIssuanceDate", "dependentsRPCancellationDate",
        "dependentVisaCancellationDate", "entryDate", "extensionIssuanceDate", "gosiTerminationDate", "gracePeriodExpiryDate",
        "iqamaExpiryDate", "ksaFinalExitDate", "laborCardCancellationDate", "laborCardExpiryDate", "lastVaccineDate",
        "lastWorkingDate", "lastWorkingDay", "loiIssueDate", "medicalExamCompletionDate", "missionExpiryCancellation",
        "missionExpiryDate", "molContractCancellationDate", "newResidencyExpirydate", "pasiContractCancellationRequestDate",
        "passportExpiryDate", "pensionCancellationDate", "pensionRegistrationDate", "pifssCancellationDate",
        "rpCancellationDate", "rpExpiryDate", "rpIssuanceDate", "rpRenewalDate", "rpTransferDate",
        "securityPermitCancellationDate", "securityPermitExpiryDate", "securityPermitIssuanceDate",
        "siCancellationDate", "siRegistrationDate", "startDate", "statusDate", "tentativeStartDate", "tentativeTravelDate",
        "transferApprovalDate", "travelDate", "visaCancellationDate", "visaCancellationExtensionDate", "visaExpiryDate",
        "visaExtensionDate", "visaIssuanceDate", "visaRenewal", "visaValidityDate", "workPermitApprovalDate",
        "workPermitCancellationDate", "workPermitExpiryDate", "workPermitIssuanceDate", "workPermitPreApprovalDate",
        "courierDispatchDate","visaTransferDate","attestationCompletedDate"
      ];
    this.common.updateDateProperty(this.model, pathWithProp);
  }
}
